module.exports = __webpack_public_path__ + "img/saum_silbergrau_ral9006.4121d0bc.jpg";